import { getAffiliates } from '../../../../entities/contracts/constants';
import { IChannel, IContracts } from '../../../../entities/contracts/types';
import { CancellationPreferenceTypes } from '../../../../entities/policies/constants';
import { SaveState } from '../../../../types';
import { ISaveState } from './reducers';

export const calcSaveState = (multiSaveState: ISaveState): SaveState => {
	if (multiSaveState.contract === SaveState.NONE || multiSaveState.cancellationPreference === SaveState.NONE) {
		return SaveState.NONE;
	} else if (multiSaveState.cancellationPreference === SaveState.FAILURE || multiSaveState.contract === SaveState.FAILURE) {
		return SaveState.FAILURE;
	} else {
		return SaveState.SUCCESS;
	}
};

export const buildCancellationPreference = (recipient: string, preference: CancellationPreferenceTypes) => {
	return {
		recipient,
		tn_cancellation_preference: preference
	};
};

export const toTitleCase = (input: string): string => {
	if (input) {
		const first = input.substring(0, 1);
		const rest = input.substring(1);
		return first.toUpperCase() + rest;
	} else {
		return input;
	}
};

export const getChannelsCount = (contracts: IContracts | null, channels: IChannel[]) => {
	const safeContracts = contracts || {};
	const selected = Object.keys(safeContracts).reduce((r, e) => {
		if (safeContracts[e]) {
			r[e] = safeContracts[e];
		}
		return r;
	}, {});
	const channelCount = Object.keys(selected).length;

	const affiliateCount = channels.reduce(
		(total: number, current: IChannel) => {
			if (selected[current.id]) {
				return total + getAffiliates(current.id).length;
			}
			return total;
		}, 0);

	return affiliateCount + channelCount;
};
